import { render, staticRenderFns } from "./Modifier.vue?vue&type=template&id=79c18860&scoped=true"
import script from "./Modifier.vue?vue&type=script&lang=js"
export * from "./Modifier.vue?vue&type=script&lang=js"
import style0 from "./Modifier.vue?vue&type=style&index=0&id=79c18860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c18860",
  null
  
)

export default component.exports